import { memo, useState } from 'react';
import { petSvg } from '@/lib/pet-svg.js';
import { cn } from '@/lib/utils';

export type Outfit = Partial<Record<'head' | 'face' | 'neck' | 'body' | 'hand', string>>;

/**
 * A companion. The SVG is built from constants only (no user text). With
 * `pettable`, a tap makes it wiggle (and calls onPet).
 */
export const Pet = memo(function Pet({
  kind = 'bunny',
  mood,
  size,
  scale,
  crown = false,
  outfit,
  label,
  pettable = false,
  onPet,
}: {
  kind?: string;
  mood: string;
  size: number;
  scale: number;
  crown?: boolean;
  outfit?: Outfit;
  label?: string;
  pettable?: boolean;
  onPet?: () => void;
}) {
  const [wiggle, setWiggle] = useState(0);
  const html = petSvg({ kind, mood: { id: mood }, size: scale, crown, outfit }, { size });
  const svg = <div key={wiggle} className={cn('grid place-items-center', wiggle > 0 && 'pet-wiggle')} dangerouslySetInnerHTML={{ __html: html }} />;
  if (!pettable) {
    return (
      <div className="grid place-items-center" role={label ? 'img' : undefined} aria-label={label}>
        {svg}
      </div>
    );
  }
  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={label}
      className="grid cursor-pointer place-items-center rounded-full outline-none select-none focus-visible:ring-2"
      onClick={(e) => {
        e.stopPropagation();
        setWiggle((w) => w + 1);
        navigator.vibrate?.(15);
        onPet?.();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setWiggle((w) => w + 1);
        }
      }}
    >
      {svg}
    </span>
  );
});
